module.exports = __webpack_public_path__ + "img/payment-processing-circle.4bd86904.gif";